import useMediaQuery from '@material-ui/core/useMediaQuery'

export const useBreakPoint = () => {
  const isPc = useMediaQuery('(min-width:768px)')
  return { isPc }
}
